import Modal from 'react-modal';
import { useState } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import * as d3 from "d3";

function StartScreen() {

  const question_mark = require("../assets/data/images/questionmark.png");

  let subtitle;
  const [modalIsOpen, setIsOpen] = useState(false);

  function hover(){
    d3.select('.vraagteken_text')
      .style('visibility', 'visible');
  }

  function mouseOut(){
    d3.select('.vraagteken_text')
      .style('visibility', 'hidden');
  }

  const modalStyle = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      height:'92vh',
      width:'75vw',
      overflow:'hidden'
    },
  };

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#726f6d';
  }

  const titleImg1 = 'Start met het beginscherm';
  const titleImg2 = 'Hover over een icoon in de buitenring om de droogteketen achter de impact te tonen. Deze droogteketen geeft de relaties tussen de achterliggende oorzaken en effecten. De directe relaties lichten op.';
  const titleImg3 = 'Klik op een icoon om de droogteketen vast te zetten en om meer informatie weer te geven over het geselecteerde icoon.';
  const titleImg4 = 'Klik op een icoon binnen de keten om meer  informatie hierover te krijgen en de directe relaties weer te geven.';
  const titleImg5 = 'Filter de keten in het zijpaneel  door actoren of  landschapstypen te verwijderen of toe te voegen. De iconen die niet aan het filter voldoen verdwijnen.';

  return (
    <div className="StartScreen" >
      <div className="questionMark" >
        <input
          type='image'
          src={question_mark}
          onClick={() => setIsOpen(true)}
          width='40'
          style={{ cursor:'pointer' }}
          alt='Rondleiding door deze visualisatie openen'
          onMouseOver={() => hover()}
          onMouseOut={() => mouseOut()}
          className='tutorial_image'
        />
        <p className='vraagteken_text'>
          Rondleiding door deze tool
        </p>
      </div>


    <Modal
      isOpen={modalIsOpen}
      onRequestClose={() => setIsOpen(false)}
      onAfterOpen={afterOpenModal}
      style={modalStyle}
      contentLabel="In dit scherm wordt een rondleiding gegeven over het gebruik van de droogteketen"
    >
      {/* <h2 ref={(_subtitle) => (subtitle = _subtitle)}>Droogteketen tutorial</h2> */}
      <button onClick={() => setIsOpen(false)} style={{ position:'absolute', right:'4px', top:'4px' }}>
        Sluiten
      </button>
      <div className='carouselStart' >
        <Carousel useKeyboardArrows autoFocus width='100%'>
          <div>
            <h3>{titleImg1}</h3>
            <br></br><br></br>
            <img alt={titleImg1} src={require("../assets/data/startscherm/Startschermv2/Startscherm1.png")} />
          </div>
          <div>
            <h3>{titleImg2}</h3>
            <br></br><br></br>
            <img alt={titleImg2} src={require("../assets/data/startscherm/Startschermv2/Startscherm2.png")} />
          </div>
          <div>
            <h3>{titleImg3}</h3>
            <br></br><br></br>
            <img alt={titleImg3} src={require("../assets/data/startscherm/Startschermv2/Startscherm3.png")} />
          </div>
          <div>
            <h3>{titleImg4}</h3>
            <br></br><br></br>
            <img alt={titleImg4} src={require("../assets/data/startscherm/Startschermv2/Startscherm4.png")} />
          </div>
          <div>
            <h3>{titleImg5}</h3>
            <br></br><br></br>
            <img alt={titleImg5} src={require("../assets/data/startscherm/Startschermv2/Startscherm5.png")} />
          </div>
        </Carousel>
      </div>

    </Modal>

  </div>
  );
}

export default StartScreen;
